<template>
	<div id="journals" class="journals">
		<table class="table table-sm table-hover">
			<thead>
				<tr>
					<th>#</th>
					<th>ASSINET</th>
					<th>Fecha</th>
					<th>Descripción</th>
					<th>Estado</th>
					<th>Asiento</th>
					<th class="text-right">
						<span data-toggle="modal" data-target="#modalJournal" ref="openModalJournal"></span>
						<i class="fas fa-plus-circle text-primary pointer" title="Nuevo Comprobante" @click="openModalJournal"></i>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in listJournals" :key="index">

				</tr>
			</tbody>
		</table>

		<!-- Modal -->
		<div class="modal" id="modalJournal" tabindex="-1" aria-labelledby="modalJournal" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="modalJournal">Nuevo Comprobante</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-row">
							<div class="form-group col-md-2">
								<label for="period">Perido</label>
								<select class="form-control form-control-sm text-right" id="period" v-model="objectJournal.PostedPeriod">
									<option v-for="(item, index) in listPeriods" :key="index" :value="item.month + item.year" :disabled="!item.open" v-if="item.open">{{ item.month }} - {{ item.year }}</option>
								</select>
							</div>
							<div class="form-group col-md-3">
								<label for="date">Fecha</label>
								<input type="date" class="form-control form-control-sm" id="date" v-model="objectJournal.JournalDate">
							</div>
							<div class="form-group col-md-6">
								<label for="description">Descripción</label>
								<input type="text" class="form-control form-control-sm" id="description" v-model="objectJournal.Description" ref="descriptionJournal">
							</div>
							<div class="form-group col-md-1 text-right">
								<i class="fas fa-external-link-alt text-info pointer" title="Traer desde Genesys" data-toggle="modal" data-target="#modalAccountingEntriesGenesys" ref="openModalAccountingEntriesGenesys"></i>
							</div>
						</div>
						<div class="p-3 mb-2 bg-light text-white new-item">
							<table class="table tabls-sm">
								<tr>
									<td class="text-right" width="100">Cuenta: </td>
									<td>
										<input type="number" style="width: 75px; border: 1px solid #ccc; margin-right: 15px;" ref="accountCode"
											v-model="objectItemJournal.AccountCode"
											@keyup.enter="analyseFieldNewItem('AccountCode')"
											@focus="$event.target.select()">
										<small><i><b>{{ objectItemJournal.AccountName }}</b></i></small>
									</td>
								</tr>
								<tr>
									<td class="text-right">Sub Cuenta: </td>
									<td>
										<input type="text" style="width: 50px; border: 1px solid #ccc; margin-right: 15px;" ref="subAccountCode"
										v-model="objectItemJournal.SubAccountCode"
										@keyup.enter="analyseFieldNewItem('SubAccountCode')"
										@focus="$event.target.select()"
										:disabled="listSubAccountsFilter.length == 0">
										<small><i><b>{{ objectItemJournal.SubAccountName }}</b></i></small>
									</td>
								</tr>
								<tr>
									<td class="text-right">Fondo: </td>
									<td>
										<input type="text" style="width: 50px; border: 1px solid #ccc; margin-right: 15px;" ref="fundCode"
										v-model="objectItemJournal.FundCode"
										@keyup.enter="analyseFieldNewItem('FundCode')"
										@focus="$event.target.select()">
										<small><i><b>{{ objectItemJournal.FundName }}</b></i></small>
									</td>
								</tr>
								<tr>
									<td class="text-right">Depto.: </td>
									<td>
										<input type="text" style="width: 50px; border: 1px solid #ccc; margin-right: 15px;" ref="functionCode"
										v-model="objectItemJournal.FunctionCode"
										@keyup.enter="analyseFieldNewItem('FunctionCode')"
										@focus="$event.target.select()">
										<small><i><b>{{ objectItemJournal.FunctionName }}</b></i></small>
									</td>
								</tr>
								<tr>
									<td class="text-right">Restricción: </td>
									<td>
										<select v-model="objectItemJournal.RestrictionCode" ref="restrictionCode"  style="width: 50px; border: 1px solid #ccc; margin-right: 15px;">
											<option v-for="(item, index) in listRestrictions" :key="index" :value="item.code">{{ item.code }}</option>
										</select>
										<small><i><b>{{ objectItemJournal.RestrictionName }}</b></i></small>
									</td>
								</tr>
								<tr>
									<td class="text-right">Valor: </td>
									<td>
										<input type="text" style="width: 150px; border: 1px solid #ccc; margin-right: 15px;" ref="entityValue"
										v-model="objectItemJournal.EntityValue"
										@keyup.enter="analyseFieldNewItem('EntityValue')"
										@focus="$event.target.select()">
										<select  style="border: 1px solid #ccc; margin-right: 15px;" v-model="objectItemJournal.TypeEntityValue">
											<option value="D">Débito</option>
											<option value="C">Crébito</option>
										</select>
									</td>
								</tr>
								<tr>
									<td class="text-right">Descripción: </td>
									<td>
										<input type="text" style="width: 100%; border: 1px solid #ccc;" ref="description"
										v-model="objectItemJournal.Description"
										@keyup.enter="analyseFieldNewItem('Description')"
										@focus="$event.target.select()">
									</td>
								</tr>
							</table>
						</div>
						<table class="table table-sm table:hover">
							<thead>
								<tr>
									<th class="text-center">Item</th>
									<th class="text-center">Cuenta</th>
									<th class="text-center">Sub-Cuenta</th>
									<th class="text-center">Fondo</th>
									<th class="text-center">Departamento</th>
									<th class="text-center">Rest.</th>
									<th class="text-center">Débito</th>
									<th class="text-center">Crédito</th>
									<th class="text-center">Descripción</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in objectJournal.Items" :key="index">
									<td>{{ index + 1 }}</td>
									<td class="text-center">{{ item.AccountCode }}</td>
									<td class="text-center">{{ item.SubAccountCode }}</td>
									<td class="text-center">{{ item.FundCode }}</td>
									<td class="text-center">{{ item.FunctionCode }}</td>
									<td>{{ item.RestrictionCode }}</td>
									<td class="text-right">{{ (item.TypeEntityValue == 'D') ? methodFormatNumber(item.EntityValue) : '' }}</td>
									<td class="text-right text-danger">{{ (item.TypeEntityValue == 'C') ? methodFormatNumber(item.EntityValue) : '' }}</td>
									<td>{{ item.Description }}</td>
									<td class="text-right"><i class="fas fa-minus-circle text-danger pointer" title="Borrar item" @click="removeItemJournal(index)"></i></td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary" @click="sendJournalToAssinet">Volvar AssiNET</button>
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal -->
		<div class="modal fade" id="modalAccountingEntriesGenesys" tabindex="1" aria-labelledby="modalAccountingEntriesGenesys" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="modalJournal">Listado de Asientos Genesys</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<nav class="navbar navbar-light bg-light">
							<div class="form-inline">
								<input class="form-control form-control-sm mr-sm-1" type="date" v-model="fromDateGenesys">
								<input class="form-control form-control-sm mr-sm-1" type="date" v-model="toDateGenesys">
								<button class="btn btn-sm btn-primary" @click="searchAsiento()">Buscar</button>
							</div>
						</nav>
						<table class="table table-sm table-hover">
							<thead>
								<tr>
									<th class="text-center">Asiento</th>
									<th class="text-center">Usuario Genesys</th>
									<th class="text-center">Agrupado</th>
									<th class="text-center">Fecha de Asiento</th>
									<th class="text-center">Fecha de Imputación</th>
									<th class="text-center">Observación</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in listAsientos" :key="index">
									<td class="text-center">{{ item.numasie }}</td>
									<td>{{ item.usuario }}</td>
									<td class="text-center">{{ (item.agrupado == '0') ? 'NO' : 'SI' }}</td>
									<td class="text-center">{{ item.fecasie }}</td>
									<td class="text-center">{{ item.fecimpu }}</td>
									<td>{{ item.observasi }}</td>
									<td><i class="far fa-arrow-alt-circle-right pointer" title="traer" @click="bring(index)"></i></td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal" ref="closeModalAccountingEntriesGenesys">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
php artisan make:controller 'API\Genesys\AccountancyGenesysController' --resource

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import accountancy from '@/mixins/accountancy/'
import journal from '@/mixins/accountancy/journal.js'
import assinet from '@/mixins/accountancy/assinet.js'
import genesys from '@/mixins/genesys'
import asiento from '@/mixins/genesys/asiento.js'


export default {
	name: 'Journals',
	mixins: [axiosAction, errors, mixin, accountancy, journal, genesys, asiento, assinet],
	data() {
		return {
			listSubAccountsFilter: []
		}
	},
	computed: {
	},
	methods: {
		analyseFieldNewItem(field) {
			switch (field) {
				case 'AccountCode':
					if(this.verifyAccountCode()) {
						if(this.listSubAccountsFilter.length > 0) {
							setTimeout(() => { this.$refs.subAccountCode.focus() }, 10);
						} else {
							this.objectItemJournal.FundCode = '10'
							this.objectItemJournal.FundName = 'Fondo Operacional'
							setTimeout(() => { this.$refs.fundCode.focus() }, 10);
						}
					}
					break;
				case 'SubAccountCode':
					if(this.verifySubAccountCode()) {
						this.objectItemJournal.FundCode = '10'
						this.objectItemJournal.FundName = 'Fondo Operacional'
						setTimeout(() => { this.$refs.fundCode.focus() }, 10);
					}
					break;
				case 'FundCode':
					if(this.verifyFundCode()) {
						setTimeout(() => { this.$refs.functionCode.focus() }, 10);
						this.$refs.functionCode.focus()
					}
					break;
				case 'FunctionCode':
					if(this.verifyFunctionCode()) {
						setTimeout(() => { this.$refs.entityValue.focus() }, 10);
					}
					break;
				case 'RestrictionCode':
					this.$refs.entityValue.focus()
					break;
				case 'EntityValue':
					this.$refs.description.focus()
					break;
				case 'Description':
					if(this.addNewObjectJournalItems(this.objectItemJournal)) {
						this.clearObjectItemJournal()
						if(confirm('¿Desea ingresar otro item?'))
							this.$refs.accountCode.focus()
					}
					break;
				default:
					break;
			}
		},
		bring(index) {
			this.objectJournal.PostedPeriod = this.listAsientos[index].fecimpu.split("-")[1] + this.listAsientos[index].fecimpu.split("-")[0]
			this.objectJournal.JournalDate = this.listAsientos[index].fecimpu
			this.objectJournal.Description = this.listAsientos[index].observasi

			this.getItemAsiento(this.listAsientos[index].numasie)
			this.$refs.closeModalAccountingEntriesGenesys.click()
		},
		initModuleLocal() {
			this.setTitleModule('Comprobantes')
			this.setSubTitleModule('')
			this.fromDateGenesys = this.currentDate(-3)
			this.toDateGenesys = this.currentDate()
		},
		openModalJournal() {
			if(this.clearObjectJournal())
				this.$refs.openModalJournal.click()
		},
		removeItemJournal(index) {
			this.deleteObjectJournalItems(index)
		},
		resultGetItemAsientoModule(response) {
			Object.values(response.data.items).forEach(val => {
				this.objectItemJournal.AccountCode = val.ctaconcod
				this.objectItemJournal.SubAccountCode = val.dsactacte
				this.objectItemJournal.FundCode = 10
				this.objectItemJournal.FunctionCode = val.dsadpto
				this.objectItemJournal.RestrictionCode = ''
				this.objectItemJournal.EntityValue = parseInt(val.imputacion)
				this.objectItemJournal.TypeEntityValue = val.tipoimp
				this.objectItemJournal.Description = val.observ
				this.objectItemJournal.Memo = ''
				this.addNewObjectJournalItems(this.objectItemJournal)
			})
			this.clearObjectItemJournal()
			if(this.objectJournal.Description.trim() == '') {
				this.$refs.descriptionJournal.focus()
			}
		},
		searchAsiento() {
			this.getAsiento(this.fromDateGenesys, this.toDateGenesys)
		},
		sendJournalToAssinet() {
			this.createXMLAssinet('ExternalMultipleAccounting', this.objectJournal)
		},
		verifyAccountCode() {
			let index = this.listAccounts.map((el) => parseInt(el.code)).indexOf(parseInt(this.objectItemJournal.AccountCode))
			this.listSubAccountsFilter = []
			if(index > -1) {
				this.objectItemJournal.AccountName = this.listAccounts[index].name
				let ind = this.listTypeSubAccounts.map((el) => el.code).indexOf(this.listAccounts[index].type_sub_account_code)
				if(ind > -1) {
					this.listSubAccountsFilter = this.listSubAccounts.filter(subAccount => {
														if(this.listTypeSubAccounts[ind].group) {
															return (subAccount.type_sub_account_code == this.listTypeSubAccounts[ind].code && subAccount.group == this.listAccounts[index].group)
														} else {
															return (subAccount.type_sub_account_code == this.listAccounts[index].code)
														}
													})
				}
				if(this.listAccounts[index].restrictions.length == 1) {
					this.objectItemJournal.RestrictionCode = this.listAccounts[index].restrictions[0]
					ind = this.listRestrictions.map((el) => el.code).indexOf(this.listAccounts[index].restrictions[0])
					this.objectItemJournal.RestrictionName = this.listRestrictions[ind].name
				}
				return true
			} else {
				this.objectItemJournal.SubAccountCode = ''
				this.objectItemJournal.SubAccountName = ''
			}
			return false
		},
		verifySubAccountCode() {
			let index = this.listSubAccountsFilter.map((el) => parseInt(el.code)).indexOf(parseInt(this.objectItemJournal.SubAccountCode))
			if(index > -1) {
				this.objectItemJournal.SubAccountName = this.listSubAccountsFilter[index].name
				return true
			}
			return false
		},
		verifyFundCode() {
			if(this.objectItemJournal.FundCode == 10) {
				return true
			}
			alert('Solo se permite el fondo: 10 - Fondo Operacional')
			this.objectItemJournal.FundCode = '10'
			return false
		},
		verifyFunctionCode() {
			let index = this.listFunctions.map((el) => parseInt(el.code)).indexOf(parseInt(this.objectItemJournal.FunctionCode))
			if(index > -1) {
				this.objectItemJournal.FunctionName = this.listFunctions[index].name
				return true
			}
			return false
		},
		verifyRestrictionCode() {
			return true
		},
		verifyEntityValue() {
			return true
		},
		verifyDescription() {
			return true
		}
	},
	components: {
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
.new-item {
	table > tr > td {
		padding: 2px 2px;
	}
}
</style>